
export const sectionStickyModeInit = (smoothScroll) => {
    const classNameFromStickySection = 'section-sticky-mode';
    const allSectionsSticky = Array.from(document.getElementsByClassName(classNameFromStickySection));

    if (!allSectionsSticky.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let updateFrame = 0;
    let scrollFrame = 0;
    let snapTimer;
    let previousScroll = window.scrollY;
    let scrollingDown = false;
    let snapFrame = 0;
    let snapping = false;
    let pointerActive = false;
    const isBlocked = () => reduced.matches || document.documentElement.classList.contains('demo-popup-open');
    const cancelSnap = () => {
        clearTimeout(snapTimer);
        cancelAnimationFrame(snapFrame);
        snapFrame = 0;
        snapping = false;
        scrollingDown = false;
        previousScroll = window.scrollY;
    };

    // Only round the entering edge; clipping a wrapper would break nested sticky content.
    const updateEdges = () => {
        scrollFrame = 0;
        allSectionsSticky.forEach((section) => {
            const top = section.getBoundingClientRect().top;
            const radius = top <= 1 ? 0 : 60 * Math.min(1, top / 50);
            section.style.setProperty('--section-edge-radius', `${radius}px`);
        });
    };
    const snapToEdge = () => {
        if (isBlocked() || !scrollingDown || snapping || pointerActive) return;
        if (smoothScroll.isActive()) {
            snapTimer = setTimeout(snapToEdge, 140);
            return;
        }
        const section = allSectionsSticky.find((item) => {
            const top = item.getBoundingClientRect().top;
            return top > 1 && top <= window.innerHeight * 0.14;
        });
        if (!section) return;
        const start = window.scrollY;
        const target = Math.min(start + section.getBoundingClientRect().top,
            Math.max(0, document.documentElement.scrollHeight - window.innerHeight));
        if (target - start <= 1) return;
        smoothScroll.stop();
        snapping = true;
        const started = performance.now();
        const tick = (time) => {
            if (isBlocked()) { cancelSnap(); return; }
            const progress = Math.min(1, (time - started) / 240);
            const eased = progress * progress * (3 - 2 * progress);
            window.scrollTo({ top: start + (target - start) * eased, behavior: 'instant' });
            previousScroll = window.scrollY;
            if (progress < 1) snapFrame = requestAnimationFrame(tick);
            else {
                // Keep the final scroll event from scheduling another snap.
                snapFrame = requestAnimationFrame(() => {
                    cancelSnap();
                    smoothScroll.stop();
                });
            }
        };
        snapFrame = requestAnimationFrame(tick);
    };
    window.addEventListener('scroll', () => {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(updateEdges);
        if (snapping) {
            if (window.scrollY < previousScroll) cancelSnap();
            return;
        }
        scrollingDown = window.scrollY > previousScroll;
        previousScroll = window.scrollY;
        clearTimeout(snapTimer);
        if (scrollingDown && !isBlocked()) snapTimer = setTimeout(snapToEdge, 140);
    }, { passive: true });
    // Capture input before the wheel controller begins its next animation.
    ['wheel', 'keydown', 'touchstart'].forEach((type) => {
        window.addEventListener(type, cancelSnap, { passive: true, capture: true });
    });
    window.addEventListener('pointerdown', () => {
        pointerActive = true;
        cancelSnap();
    }, { passive: true });
    ['pointerup', 'pointercancel'].forEach((type) => {
        window.addEventListener(type, () => {
            pointerActive = false;
            if (scrollingDown) snapTimer = setTimeout(snapToEdge, 140);
        }, { passive: true });
    });
    window.addEventListener('resize', cancelSnap);
    reduced.addEventListener('change', cancelSnap);
    const lockObserver = new MutationObserver(() => {
        if (isBlocked()) {
            cancelSnap();
            smoothScroll.stop();
        }
    });
    lockObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    const updateSectionOffsets = () => {
        updateFrame = 0;

        const viewportHeight = window.innerHeight;

        allSectionsSticky.forEach((section) => {
            const stickyOffset = Math.max(0, section.offsetHeight - viewportHeight);

            section.style.setProperty('--section-sticky-offset', `${stickyOffset}px`);
        });
        updateEdges();
    };

    const requestSectionOffsetsUpdate = () => {
        if (updateFrame) {
            return;
        }

        updateFrame = requestAnimationFrame(updateSectionOffsets);
    };

    const resizeObserver = new ResizeObserver(requestSectionOffsetsUpdate);

    allSectionsSticky.forEach((section) => {
        resizeObserver.observe(section);
    });

    window.addEventListener('resize', requestSectionOffsetsUpdate);
    window.addEventListener('load', requestSectionOffsetsUpdate);

    requestSectionOffsetsUpdate();
};
